/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RightsideNavitemsService {

  constructor(private http: HttpClient) { }

  getRightsideNavItems(navListType, pageKey) {
    return new Promise(resolve => {
      return this.http
        .get('./assets/menus/right-side-nav.json').subscribe(data => {
          const asideMenus = data[navListType];
          const menuOptionSelected = asideMenus.find(menuOption => menuOption['pageKey'] === pageKey);
          menuOptionSelected['isSelected'] = true;
          resolve(asideMenus);
        });
    });
  }
}
